import { render, staticRenderFns } from "./AccountDelete.vue?vue&type=template&id=48401f16"
import script from "./AccountDelete.vue?vue&type=script&lang=js"
export * from "./AccountDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports